var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-secondary btn-print",on:{"click":_vm.printCallback}},[_c('img',{attrs:{"src":_vm.icon,"alt":""}}),_vm._v(" Print ")])}
var staticRenderFns = []

export { render, staticRenderFns }